import classNames from 'classnames';
import React from 'react';
import { Indicators } from '../indicators';
import { Name } from '../name';
import { useVideoConfig } from '../../../video-config-provider';
import s from './content.scss';
export var Content = function (_a) {
    var _b;
    var children = _a.children, className = _a.className, attendeeId = _a.attendeeId, hideIndicators = _a.hideIndicators, focused = _a.focused;
    var dashboard = useVideoConfig().dashboard;
    return (React.createElement("div", { className: classNames(s.container, className, (_b = {}, _b[s.dashboardContainer] = dashboard, _b)) },
        children,
        React.createElement(Name, { focused: focused, attendeeId: attendeeId }),
        !hideIndicators && React.createElement(Indicators, { attendeeId: attendeeId })));
};
//# sourceMappingURL=content.js.map